import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Table, Loader, Popup} from 'semantic-ui-react';
import _ from 'lodash';
import {Actions} from '../../../../../common/actions';

class StockTdeModals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
    };
  }

  fetchData() {
    const {code} = this.props;
    this.props.fetchTdeStockDetail(code);
    this.setState({'modalWasOpen': true});
  }

  renderTdeStock(tdeStock) {
    if (!tdeStock || Object.keys(tdeStock).length === 0) {
      return (
        <Table>
          <Table.Body>
            <Table.Row>
              <Table.Cell textAlign='center'>
                No hay datos disponibles
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }
    return (
      <Table striped className='toyota-grid'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>En Stock</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Reservado</Table.HeaderCell>
            <Table.HeaderCell textAlign='center' className='right-divider'>
              Disponible
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center' className='header-secondary'>
              Binning
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center' className='header-secondary'>
              Confirmado
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center' className='header-secondary'>
              En Tránsito
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell textAlign='center'>{tdeStock.stock || 0}</Table.Cell>
            <Table.Cell textAlign='center'>{tdeStock.reserved || 0}</Table.Cell>
            <Table.Cell textAlign='center' className='right-divider'>
              {tdeStock.available || 0}
            </Table.Cell>
            <Table.Cell textAlign='center'>
              {tdeStock.inBinning || 0}
            </Table.Cell>
            <Table.Cell textAlign='center'>
              {tdeStock.confirmed || 0}
            </Table.Cell>
            <Table.Cell textAlign='center'>
              {tdeStock.inTransit || 0}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  renderWareHouseStock(warehouseStock) {
    if (!warehouseStock || warehouseStock.length === 0) {
      return (
        <Table>
          <Table.Body>
            <Table.Row>
              <Table.Cell textAlign='center'>
                No hay datos disponibles
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }
    return (
      <Table striped className='toyota-grid table-width-auto'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center' colSpan={2}>
              TDE
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row className='row-title'>
            <Table.Cell textAlign='center'>Bodega</Table.Cell>
            <Table.Cell textAlign='center'>Exist.</Table.Cell>
          </Table.Row>
          {this.renderWareHouseStockData(warehouseStock)}
          <Table.Row className='row-title'>
            <Table.Cell textAlign='center'>Total</Table.Cell>
            <Table.Cell textAlign='center'>
              {_.sumBy(warehouseStock, 'stock')}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  renderWareHouseStockData(wareHouseStock) {
    return wareHouseStock.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.warehouse}</Table.Cell>
          <Table.Cell textAlign='center'>{element.stock}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {
      quantity,
      quantityAvailable,
      loadingTdeStockDetail,
      tdeStockDetail,
    } = this.props;
    const {modalWasOpen} = this.state;
    const existDataAfterCallApi =
      modalWasOpen &&
      tdeStockDetail &&
      tdeStockDetail.tdeStock &&
      tdeStockDetail.tdeStock.stock;
    if (
      (existDataAfterCallApi && tdeStockDetail.tdeStock.stock === 0) ||
      !quantity
    ) {
      return (
        <span>
          <Popup
            trigger={<span>{0}</span>}
            content='Stock total'
            position='top center'
            inverted
          />
          <Popup
            trigger={<span className='margin-left'>({quantityAvailable})</span>}
            content='Stock Disponible'
            position='top center'
            inverted
          />
        </span>
      );
    }

    return (
      <Modal
        centered={false}
        size='small'
        onOpen={() => this.fetchData()}
        trigger={
          <span className='link'>
            <Popup
              trigger={
                <span>
                  {existDataAfterCallApi ?
                    tdeStockDetail.tdeStock.stock :
                    quantity}
                </span>
              }
              content='Stock Total'
              position='top center'
              inverted
            />

            <Popup
              trigger={
                <span className='margin-left'>({quantityAvailable})</span>
              }
              content='Stock Disponible'
              position='top center'
              inverted
            />
          </span>
        }
        closeIcon
      >
        <Modal.Header>
          Stock TDE
          <span className='quantity-container'>
            {existDataAfterCallApi ? tdeStockDetail.tdeStock.stock : quantity}
          </span>
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            {loadingTdeStockDetail && <Loader active inline='centered' />}
            {!loadingTdeStockDetail &&
              this.renderTdeStock(tdeStockDetail.tdeStock)}
            {!loadingTdeStockDetail &&
              this.renderWareHouseStock(tdeStockDetail.warehouseStock)}
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loadingTdeStockDetail': state.partModals.loadingTdeStockDetail,
    'tdeStockDetail': state.partModals.tdeStockDetail,
  };
};

const {fetchTdeStockDetail} = Actions;

export default connect(mapStateToProps, {
  fetchTdeStockDetail,
})(StockTdeModals);
